export const salesFormSchema = [
	{
		type: "custom",
		children: "Sales Details",
		classes: { wrapper: "px-2 w-full font-bold pb-2" },
	},
	{
		type: "field",
		fieldType: "input",
		name: "compaignName",
		label: "Campaign Name",
		isRequired: true,
		fieldProps: {
			placeholder: "Enter Campaign Name",
			note: "*Do not exceed 20 characters for the name",
			maxLength: 20,
		},
		validations: {
			required: ["Campaign Name is required."],
		},
		classes: { wrapper: "px-2 w-full" },
	},
	{
		type: "field",
		fieldType: "select",
		name: "brand",
		label: "Brand",
		isRequired: true,
		fieldProps: {
			placeholder: "Choose Brand",
			options: ["House Of Fashion", "Brand B", "Brand C"],
		},
		validations: {
			required: ["Brand is required."],
		},
		classes: { wrapper: "px-2 w-full md:w-1/2" },
	},
	{
		type: "field",
		fieldType: "textarea",
		name: "saleDescription",
		label: "Sale Description",
		isRequired: true,
		fieldProps: {
			placeholder: "Enter a Brief Description",
			caption: "*Do not exceed 200 characters for the description",
			maxLength: 200,
			rows: 5,
		},
		validations: {
			required: ["Product description is required."],
		},
		classes: { wrapper: "px-2 w-full" },
	},
	{
		type: "custom",
		children: "Discount Detail",
		classes: { wrapper: "px-2 w-full font-bold py-2" },
	},
	// Radio Button
	{
		type: "field",
		fieldType: "radio",
		name: "discountType",
		isRequire: true,
		fieldProps: {
			options: ["Percentage Discount", "Flat Amount Off"],
		},
		label: "Discount Type",
		validations: {
			required: ["Discount type is required."],
		},
		classes: { wrapper: "px-2 w-full font-bold py-2" },
	},

	{
		type: "field",
		fieldType: "input",
		name: "discountPercentage",
		label: "Discount Percentage",
		isRequired: true,
		fieldProps: {
			type: "number",
			placeholder: "Enter Discount Percentage",
		},
		validations: {
			required: ["Discount Percentage is required."],
		},
		classes: { wrapper: "px-2 w-full md:w-1/2" },
	},
	{
		type: "custom",
		children: "Sales Validity",
		classes: { wrapper: "mt-4 px-2 w-full font-bold py-2" },
	},
	{
		type: "field",
		fieldType: "date",
		name: "startDate",
		label: "Start Date",
		isRequired: true,
		fieldProps: {
			placeholder: "DD/MM/YYYY",
		},
		validations: {
			required: ["Start Date is required."],
		},
		classes: { wrapper: "px-2 w-full md:w-1/2 px-2 " },
	},
	{
		type: "field",
		fieldType: "date",
		name: "endDate",
		label: "End Date",
		isRequired: true,
		fieldProps: {
			placeholder: "DD/MM/YYYY",
		},
		validations: {
			required: ["End Date is required."],
		},
		classes: { wrapper: "px-2 w-full md:w-1/2 px-2" },
	},
	{
		type: "field",
		fieldType: "time",
		name: "startTime",
		label: "Start Time",
		isRequired: true,
		fieldProps: {
			placeholder: "HH:MM",
		},
		validations: {
			required: ["Start Time is required."],
		},
		classes: { wrapper: "px-2 w-full md:w-1/2 px-2 " },
	},
	{
		type: "field",
		fieldType: "time",
		name: "endTime",
		label: "End Time",
		isRequired: true,
		fieldProps: {
			placeholder: "HH:MM",
		},
		validations: {
			required: ["End Time is required."],
		},
		classes: { wrapper: "px-2 w-full md:w-1/2 px-2 " },
	},

	// {
	// 	type: "custom",
	// 	children: "Shipping Details",
	// 	classes: { wrapper: "px-2 w-full font-bold pb-2" },
	// },
	{
		type: "field",
		fieldType: "select",
		name: "productCategories",
		label: "Product Categories",
		isRequired: true,
		fieldProps: {
			placeholder: "Select Product Category",
			multiple: true,
			options: ["a", "b", "c"],
		},
		validations: {
			required: ["Category is required."],
		},
		classes: { wrapper: "px-2 w-full" },
	},
	{
		type: "field",
		fieldType: "select",
		name: "productSubCategories",
		label: "Product Sub-Categories",
		fieldProps: {
			placeholder: "Select Product Sub Categories",
			multiple: true,
			options: ["a", "b", "c"],
		},
		classes: { wrapper: "px-2 w-full" },
	},
	{
		type: "field",
		fieldType: "select",
		name: "productIds",
		label: "Product ID",
		fieldProps: {
			placeholder: "Select Product ID",
			multiple: true,
			options: ["a", "b", "c"],
		},
		classes: { wrapper: "px-2 w-full" },
	},
	{
		type: "custom",
		children: "Sales Banner",
		classes: { wrapper: "mt-4 px-2 w-full font-bold py-2" },
	},
	{
		type: "field",
		fieldType: "fileUpload",
		name: "document",
		label: "Upload Document",
		fieldProps: {
			note: "Max 10MB files are allowed",
			caption: "*Only Supports jpg, png and svg files",
			// filePreview: true,
			// accept: "image/jpg",
		},
		classes: { wrapper: "px-2 w-full font-bold py-2" },
	},
	{
		type: "custom",
		identifier: "actionBtn",
		classes: { wrapper: "px-2 w-full py-2" },
	},
];

export const uploadImagesFormSchema = [];
